import React from 'react';
import b_ from 'b_';
import cn from 'classnames';
import './Tile.scss';

const b = b_.lock('Tile');

const Tile = ({
  className,
  defaultStyles = true,
  as,
  ...props
}) => {
  const Component = as || 'div';
  return <Component className={cn(b({ defaultStyles }), className)} {...props} />;
};

export default Tile;
